'use client';

import { Separator } from '@ui/components/ui/separator';
import { SidebarTrigger } from '@ui/components/ui/sidebar';
import { DynamicBreadcrumb } from './dynamic-breadcrumb';
import Filters from '../filter';
import { useFilters } from '@/contexts/app-context';

export default function Topbar() {
  const { hasFilterOptions } = useFilters();
  return (
    <header className="sticky top-0 lg:static grid grid-cols-5 h-20 lg:h-16 px-4 md:px-6 shrink-0 items-center border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 z-50">
      <div className={`col-span-5 ${hasFilterOptions && 'lg:col-span-1'} flex items-center gap-2`}>
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="data-[orientation=vertical]:h-4" />
        <DynamicBreadcrumb />
      </div>
      {/* Filter takes same cols as breadcrumbs */}
      <Filters />
    </header>
  );
}
